import _ from 'lodash';
import validate from '@/helpers/validation';

export default {
  data() {
    return {
      refs: [],
      terms: [],
      saveErrorMessage: 'Error in data saving',
    };
  },

  computed: {
    $_featuredBlocksList() {
      return ['none'].concat(this.$store.state.homeSections);
    },
  },

  methods: {
    $_validate(fields) {
      return validate(fields, this.$_showError);
    },
    // Funcs for saving
    $_addDefaultFormData() {
      const postFormData = new FormData();
      const references = { items: this.refs.map(item => ({ id: item.id, type: item.type })) };
      postFormData.append('published', this.entity.published ? true : '');
      postFormData.append('path_alias', this.entity.path_alias);
      postFormData.append('seo_title', this.entity.seo_title);
      postFormData.append('seo_description', this.entity.seo_description);
      if (this.entity.summary) postFormData.append('summary', this.entity.summary);
      if (references.items.length) postFormData.append('references', JSON.stringify(references));
      if (this.terms.length) postFormData.append('terms', JSON.stringify(this.terms.map(item => item.id)));
      return postFormData;
    },
    $_successSave() {
      $('.btn-success .btn-loader').hide();
      $('.saving-alerts .alert-success').show();
    },
    $_errorSave(errorObj) {
      if (_.has(errorObj, 'response.data')) {
        const { data } = errorObj.response;
        if (data.errors) {
          let msg = '';
          Object.keys(data.errors).map(el => data.errors[el]).forEach((el) => {
            msg += el.join('\n');
            msg += '\n';
          });
          this.$_showError(msg);
        } else if (data.message) {
          this.$_showError(data.message);
        } else {
          this.$_showError('Error in data saving');
        }
      } else {
        this.$_showError('Error in data saving');
      }
    },

    // Funcs for validation
    $_showError(errorMessage) {
      $('.btn-success .btn-loader').hide();
      this.saveErrorMessage = errorMessage;
      $('.saving-alerts .alert-danger').show();
    },

    // Funcs for refs and terms
    $_changeRefs(newRefs) {
      this.refs = newRefs;
    },
    $_changeTerms(newTerms) {
      this.terms = newTerms;
    },

    // Funcs for cover
    $_coverChange(file) {
      this.entity.cover = file;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/CreatePageMixin.js